/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

exports.onRouteUpdate = function({ location }) {
   // Don't track while developing
  if (process.env.NODE_ENV === 'production' && typeof gtag === 'function') {
    // Send pageview
    window.gtag('config', 'UA-118386653-1', {'page-path': location ? location.pathname + location.search + location.hash : undefined })
  }
}


// WEBPACK FOOTER //
// ./gatsby-browser.js